/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'
import type { PaginatedPortfolioWorkListAdmin } from './PaginatedPortfolioWorkListAdmin'
import {
  PaginatedPortfolioWorkListAdminFromJSON,
  PaginatedPortfolioWorkListAdminFromJSONTyped,
  PaginatedPortfolioWorkListAdminToJSON,
} from './PaginatedPortfolioWorkListAdmin'

/**
 *
 * @export
 * @interface EnvelopedPortfolioWorkListPortfolioWorkListAdmin
 */
export interface EnvelopedPortfolioWorkListPortfolioWorkListAdmin {
  /**
   *
   * @type {PaginatedPortfolioWorkListAdmin}
   * @memberof EnvelopedPortfolioWorkListPortfolioWorkListAdmin
   */
  body: PaginatedPortfolioWorkListAdmin
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedPortfolioWorkListPortfolioWorkListAdmin
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedPortfolioWorkListPortfolioWorkListAdmin interface.
 */
export function instanceOfEnvelopedPortfolioWorkListPortfolioWorkListAdmin(
  value: object,
): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedPortfolioWorkListPortfolioWorkListAdminFromJSON(
  json: any,
): EnvelopedPortfolioWorkListPortfolioWorkListAdmin {
  return EnvelopedPortfolioWorkListPortfolioWorkListAdminFromJSONTyped(json, false)
}

export function EnvelopedPortfolioWorkListPortfolioWorkListAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedPortfolioWorkListPortfolioWorkListAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: PaginatedPortfolioWorkListAdminFromJSON(json['body']),
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedPortfolioWorkListPortfolioWorkListAdminToJSON(
  value?: EnvelopedPortfolioWorkListPortfolioWorkListAdmin | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: PaginatedPortfolioWorkListAdminToJSON(value.body),
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
